export default {
  title: 'Select Product',
};
